function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { DvrWindowDuration, StreamVendor } from '../../core/player/playout-data';
import { sdkLogger } from '../../logger';
import { HARMONIC_2H_PATH, HARMONIC_2M_PATH, HARMONIC_EVENT_PATH, HARMONIC_V1, HARMONIC_V1_2M_PATH, HARMONIC_V2, ISTREAMPLANET_2H_PATH, ISTREAMPLANET_2M_PATH, ISTREAMPLANET_EVENT_PATH } from '../../utils/stream-vendor';
var HarmonicEndpoint = /*#__PURE__*/ function() {
    "use strict";
    function HarmonicEndpoint(stream) {
        _class_call_check(this, HarmonicEndpoint);
        _define_property(this, "stream", void 0);
        this.stream = stream;
    }
    _create_class(HarmonicEndpoint, [
        {
            key: "buildRestrictedDvrWindowUrl",
            value: function buildRestrictedDvrWindowUrl(endpointUrl) {
                if (this.stream.windowDuration === DvrWindowDuration.Extended) {
                    endpointUrl = endpointUrl.replace(HARMONIC_2H_PATH, HARMONIC_2M_PATH);
                } else if (this.stream.windowDuration === DvrWindowDuration.FullEvent) {
                    endpointUrl = endpointUrl.replace(HARMONIC_EVENT_PATH, HARMONIC_2M_PATH);
                }
                return endpointUrl;
            }
        },
        {
            key: "buildExtendedDvrWindowUrl",
            value: function buildExtendedDvrWindowUrl(endpointUrl) {
                if (!endpointUrl.includes(HARMONIC_V2)) {
                    endpointUrl = endpointUrl.replace(HARMONIC_V1, HARMONIC_V2).replace(HARMONIC_V1_2M_PATH, HARMONIC_2M_PATH);
                }
                if (this.stream.windowDuration === DvrWindowDuration.Restricted) {
                    endpointUrl = endpointUrl.replace(HARMONIC_2M_PATH, HARMONIC_2H_PATH);
                } else if (this.stream.windowDuration === DvrWindowDuration.FullEvent) {
                    endpointUrl = endpointUrl.replace(HARMONIC_EVENT_PATH, HARMONIC_2H_PATH);
                }
                return endpointUrl;
            }
        },
        {
            key: "buildFullEventDvrWindowUrl",
            value: function buildFullEventDvrWindowUrl(endpointUrl) {
                if (!endpointUrl.includes(HARMONIC_V2)) {
                    endpointUrl = endpointUrl.replace(HARMONIC_V1, HARMONIC_V2).replace(HARMONIC_V1_2M_PATH, HARMONIC_2M_PATH);
                }
                if (this.stream.windowDuration === DvrWindowDuration.Restricted) {
                    endpointUrl = endpointUrl.replace(HARMONIC_2M_PATH, HARMONIC_EVENT_PATH);
                } else if (this.stream.windowDuration === DvrWindowDuration.Extended) {
                    endpointUrl = endpointUrl.replace(HARMONIC_2H_PATH, HARMONIC_EVENT_PATH);
                }
                return endpointUrl;
            }
        }
    ]);
    return HarmonicEndpoint;
}();
var IStreamPlanetEndpoint = /*#__PURE__*/ function() {
    "use strict";
    function IStreamPlanetEndpoint(stream) {
        _class_call_check(this, IStreamPlanetEndpoint);
        _define_property(this, "stream", void 0);
        this.stream = stream;
    }
    _create_class(IStreamPlanetEndpoint, [
        {
            key: "buildRestrictedDvrWindowUrl",
            value: function buildRestrictedDvrWindowUrl(endpointUrl) {
                if (this.stream.windowDuration === DvrWindowDuration.Extended) {
                    endpointUrl = endpointUrl.replace(ISTREAMPLANET_2H_PATH, ISTREAMPLANET_2M_PATH);
                } else if (this.stream.windowDuration === DvrWindowDuration.FullEvent) {
                    endpointUrl = endpointUrl.replace(ISTREAMPLANET_EVENT_PATH, ISTREAMPLANET_2M_PATH);
                }
                return endpointUrl;
            }
        },
        {
            key: "buildExtendedDvrWindowUrl",
            value: function buildExtendedDvrWindowUrl(endpointUrl, capabilities) {
                var _capabilities_supportsExtendedDvrOnIsp;
                if (!(capabilities === null || capabilities === void 0 ? void 0 : (_capabilities_supportsExtendedDvrOnIsp = capabilities.supportsExtendedDvrOnIsp) === null || _capabilities_supportsExtendedDvrOnIsp === void 0 ? void 0 : _capabilities_supportsExtendedDvrOnIsp.call(capabilities))) {
                    return endpointUrl;
                }
                if (this.stream.windowDuration === DvrWindowDuration.Restricted) {
                    endpointUrl = endpointUrl.replace(ISTREAMPLANET_2M_PATH, ISTREAMPLANET_2H_PATH);
                } else if (this.stream.windowDuration === DvrWindowDuration.FullEvent) {
                    endpointUrl = endpointUrl.replace(ISTREAMPLANET_EVENT_PATH, ISTREAMPLANET_2H_PATH);
                }
                return endpointUrl;
            }
        },
        {
            key: "buildFullEventDvrWindowUrl",
            value: function buildFullEventDvrWindowUrl(endpointUrl) {
                sdkLogger.warn('FullEvent not supported for ISP');
                return endpointUrl;
            }
        }
    ]);
    return IStreamPlanetEndpoint;
}();
function assertUnknownVendor(vendor) {
    throw new Error("Unknown vendor: ".concat(vendor));
}
export var LinearStreamEndpointFactory = /*#__PURE__*/ function() {
    "use strict";
    function LinearStreamEndpointFactory() {
        _class_call_check(this, LinearStreamEndpointFactory);
    }
    _create_class(LinearStreamEndpointFactory, null, [
        {
            key: "fromVendor",
            value: function fromVendor(stream) {
                switch(stream.vendor){
                    case StreamVendor.Harmonic:
                        return new HarmonicEndpoint(stream);
                    case StreamVendor.IStreamPlanet:
                        return new IStreamPlanetEndpoint(stream);
                    default:
                        break;
                }
                return assertUnknownVendor(stream.vendor);
            }
        }
    ]);
    return LinearStreamEndpointFactory;
}();

//# sourceMappingURL=peacock-linear-cdn-builder.js.map